import useGetRequestBody from "../../useGetRequestBody";
import { getAssetTypes } from "../../../requests/type-requests";
import {useMemo} from "react";

import {SnackbarShowMessage} from "../../../context/snackbar-context";

export interface IAssetType {
  value: string;
  key: string;
}

/**
 * Custom hook to fetch all asset types and prepend an "All" option for use in dropdowns.
 * @param showMessage - function to show messages from the api response, optional
 * @returns {IAssetType[]}
 */
const useAllAssetTypes = (showMessage?: SnackbarShowMessage): IAssetType[] => {
  const allAssetTypes: IAssetType[] = useGetRequestBody(getAssetTypes, useMemo(() => [], []), showMessage);
  return useMemo(() => [{key: '', value: 'All'}, ...allAssetTypes], [allAssetTypes]);
};

export default useAllAssetTypes;
